import React, { Component } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import axios from "axios";

import { createBrowserHistory } from "history";

import Home from "views/home/Home";
import JobDetails from "views/job-details/JobDetails";
import JobListing from "views/job-listing/JobListing";
import WhatsNew from "views/whats-new/WhatsNew";
import ITV from "views/ITV-details/ITV";
import ContactUs from "views/contactUs/ContactUs";
import KnowUsMore from "views/know-us-more/KnowUsMore";
import Profile from "views/profile/ProfileMain";
import Error404 from "views/service-pages/Error404";
import ThreeD from "components/Navbars/components/ThreeD";
import maintenace from "views/service-pages/maintenace";
import portfolioList from "views/know-us-more/KnowusMoreListing";
import Ilearn from "views/ilearn/Ilearn";
import IlearnDetails from "views/ilearn/ilearndetails/IlearnDetails";
import MainLogin from "views/stepPortal/login/MainLogin";

import TimeLine from "views/profile/components/my-activities/components/TimeLine";
import Spinner from "utility/spinner";
import store from "store.js";
import { connect } from "react-redux";
// views without layouts
class Main extends Component {
  constructor(props) {
    super(props);
    //--- if reload page set Authorization header ----
    // axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
  }

  render() {
    return (
      <div>
        <Spinner loading={this.props.Auth.ISLOADING} />
        <Route path={`${process.env.PUBLIC_URL}/PGDFB`} exact component={JobDetails} />
        {/* <Route
          path={`${process.env.PUBLIC_URL}/Career/Home`}
          exact
          component={Home}
        /> */}
        <Route
          path={`${process.env.PUBLIC_URL}/Career/job-details/:JID`}
          exact
          component={JobDetails}
        />
        {/* <Route
          path={`${process.env.PUBLIC_URL}/Career/job-listing`}
          exact
          component={JobListing}
        /> */}
        {/* <Route
          path={`${process.env.PUBLIC_URL}/Career/ITV`}
          exact
          component={ITV}
        /> */}
        {/* <Route
          path={`${process.env.PUBLIC_URL}/Career/whats-new`}
          exact
          component={WhatsNew}
        /> */}
        {/* <Route
          path={`${process.env.PUBLIC_URL}/Career/contact-us`}
          exact
          component={ContactUs}
        /> */}

        {/* <Route
          path={`${process.env.PUBLIC_URL}/Career/know-us-more/:PID`}
          exact
          component={KnowUsMore}
        />

        <Route
          path={`${process.env.PUBLIC_URL}/Career/profile`}
          exact
          component={Profile}
        /> */}
        {/* <Route
          path={`${process.env.PUBLIC_URL}/Career/ilearn`}
          exact
          component={Ilearn}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/Career/ilearn-details/:CourseId`}
          exact
          component={IlearnDetails}
        />
        <Route
          path={process.env.PUBLIC_URL + "/Career/profile/:f_id"}
          component={TimeLine}
        /> */}

        <Route
          path={process.env.PUBLIC_URL + "/Career/404-error"}
          component={Error404}
        />

        <Route
          path={process.env.PUBLIC_URL + "/Career/maintenace"}
          component={maintenace}
        />
        <Route
          path={process.env.PUBLIC_URL + "/Career/3d"}
          component={ThreeD}
        />
        <Route
          path={process.env.PUBLIC_URL + "/Career/login"}
          component={MainLogin}
        />
        {/* <Redirect to={`${process.env.PUBLIC_URL}/Career/Home`} /> */}
      </div>
    );
  }
}
export const history = createBrowserHistory({
  basename: process.env.PUBLIC_URL,
});

// export default Main;
const mapStateToProps = (state) => {
  return {
    Auth: state.Auth.user,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};
export default connect(mapStateToProps, mapDispatchToProps)(Main);
